/* eslint-disable import/no-named-as-default-member */
/**
 * reducers
 */
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
// @ts-ignore
import { submittingReducer } from 'shared';

// @ts-ignore
import { reducer as timekeeperReducer } from './workspaces/redux-timekeeper';
// @ts-ignore
import { reducer as errorBoundariesReducer } from './workspaces/redux-error-boundary';
import activeIngredientsReducer from './services/activeIngredients/reducer';
// @ts-ignore
import authReducer from './services/auth/reducer';
import columnWidthsReducer from './services/columnWidths/reducer';
// @ts-ignore
import commoditiesReducer from './services/commodities/reducer';
// @ts-ignore
import connectionReducer from './services/connection/reducer';
// @ts-ignore
import containerGroupsReducer from './services/containerGroups/reducer';
// @ts-ignore
import countsReducer from './services/counts/reducer';
// @ts-ignore
import currentEntityIdReducer from './services/currentEntityId/reducer';
// @ts-ignore
import currentNumberOfDaysReducer from './services/currentNumberOfDays/reducer';
// @ts-ignore
import currentOrganizationIdReducer from './services/currentOrganizationId/reducer';
// @ts-ignore
import currentSeasonIdReducer from './services/currentSeasonId/reducer';
// @ts-ignore
import datesReducer from './services/dates/reducer';
// @ts-ignore
import descriptionSnippetsReducer from './services/descriptionSnippets/reducer';
// @ts-ignore
import documentSetsReducer from './services/documentSets/reducer';
// @ts-ignore
import entitiesReducer from './services/entities/reducer';
// @ts-ignore
import entityTypesReducer from './services/entityTypes/reducer';
// @ts-ignore
import errorReducer from './services/error/reducer';
// @ts-ignore
import eventsReducer from './services/events/reducer';
// @ts-ignore
import finalFormsReducer from './services/finalForms/reducer';
// @ts-ignore
import finalFormsUnsavedValuesReducer from './services/finalFormsUnsavedValues/reducer';
// @ts-ignore
import groupsReducer from './services/groups/reducer';
// @ts-ignore
import groupEntitiesReducer from './services/groupEntities/reducer';
// @ts-ignore
import groupPeopleReducer from './services/groupPeople/reducer';
import harvestEventDocumentsReducer from './services/harvestEventDocuments/reducer';
// @ts-ignore
import harvestEventsReducer from './services/harvestEvents/reducer';
import harvestPrintPropertiesReducer from './services/harvestPrintProperties/reducer';
// @ts-ignore
import hashesReducer from './services/hashes/reducer';
// @ts-ignore
import hideUnusedGroupsReducer from './services/hideUnusedGroups/reducer';
// @ts-ignore
import initialDataLoadedReducer from './services/initialDataLoaded/reducer';
// @ts-ignore
import loadingReducer from './services/loading/reducer';
// @ts-ignore
import notificationsReducer from './services/notifications/reducer';
// @ts-ignore
import organizationsReducer from './services/organizations/reducer';
import organizationConfigReducer from './services/organizationConfig/reducer';
// @ts-ignore
import peopleReducer from './services/people/reducer';
// @ts-ignore
import pickTypesReducer from './services/pickTypes/reducer';
// @ts-ignore
import quantityForecastsReducer from './services/quantityForecasts/reducer';
// @ts-ignore
import resetPasswordReducer from './services/resetPassword/reducer';
// @ts-ignore
import reportsHarvestInspectionsReducer from './services/reportsHarvestInspections/reducer';
// @ts-ignore
import reportsHarvestInspectionsPeopleReducer from './services/reportsHarvestInspectionsPeople/reducer';
// @ts-ignore
import resultsReducer from './services/results/reducer';
// @ts-ignore
import rolesReducer from './services/roles/reducer';
// @ts-ignore
import schemasReducer from './services/schemas/reducer';
// @ts-ignore
import schemaAttributesReducer from './services/schemaAttributes/reducer';
// @ts-ignore
import searchesReducer from './services/searches/reducer';
// @ts-ignore
import seasonsReducer from './services/seasons/reducer';
// @ts-ignore
import selectedTableCellsReducer from './services/selectedTableCells/reducer';
// @ts-ignore
import sharedEventReducer from './services/sharedEvent/reducer';
import sprayEventsReducer from './services/sprayEvents/reducer';
import sprayEventsForSubmissionReducer from './services/sprayEventsForSubmission/reducer';
import timesheetTimesheetEntriesAPIErrorsReducer from './services/timesheetTimesheetEntriesAPIErrors/reducer';
// @ts-ignore
import timesheetReducer from './services/timesheet/reducer';
// @ts-ignore
import timesheetEntriesReducer from './services/timesheetEntries/reducer';
// @ts-ignore
import timesheetsReducer from './services/timesheets/reducer';
// @ts-ignore
import timesheetTimesheetEntriesReducer from './services/timesheetTimesheetEntries/reducer';
import uiReducer from './services/ui/reducer';
// @ts-ignore
import userEntityAssignmentsReducer from './services/userEntityAssignments/reducer';
// @ts-ignore
import usersMeReducer from './services/usersMe/reducer';
// @ts-ignore
import varietiesReducer from './services/varieties/reducer';
import virtualizedTableReducer from './services/virtualizedTable/reducer';
// @ts-ignore
import workTypesReducer from './services/workTypes/reducer';
// @ts-ignore
import onlyMyTimesheetsCheckboxReducer from './services/onlyMyTimesheetsCheckbox/reducer';
// @ts-ignore
import myTimesheetEntriesReducer from './services/myTimesheetEntries/reducer';
import equipmentSetsReducer from './services/equipmentSets/reducer';
import productTypesReducer from './services/productTypes/reducer';
import productsReducer from './services/products/reducer';
import waterSourceReducer from './services/waterSource/reducer';
import unitTypesReducer from './services/unitTypes/reducer';
import equipmentReducer from './services/equipment/reducer';
import worksheetReducer from './services/worksheet/reducer';
import sprayEventWizardReducer from './services/sprayEventWizard/reducer';
import sprayEventMultipleOperatorsTabReducer from './services/sprayEventMultipleOperatorsTab/reducer';
import sprayedEntitiesByDateReducer from './services/sprayedEntitiesByDate/reducer';
import timesheetHolidaysReducer from './services/timesheetHolidays/reducer';
import payrollExportReducer from './services/payrollExports/reducer';
import spraySubmissionsReducer from './services/spraySubmissions/reducer';
import spraySubmissionReducer from './services/spraySubmission/reducer';
import selectedSprayEventIdsForSubmissionReducer from './services/selectedSprayEventIdsForSubmission/reducer';
import activeSeasonAlertReducer from './services/activeSeasonAlert/reducer';
import fertilizerProductsReducer from './services/fertilizerProducts/reducer';
import fertilizerEventsReducer from './services/fertilizerEvents/reducer';
import appliedFertilizerEntitiesByDateReducer from './services/appliedFertilizerEntitiesByDate/reducer';
import sprayEventTypeReducer from './services/sprayEventType/reducer';
import documentsReducer from './services/documents/reducer';
import reEntryWarningReducer from './services/reEntryWarning/reducer';
import cropsurePasswordsReducer from './services/cropsurePasswords/reducer';

export default (history: any): any =>
    combineReducers({
        router: connectRouter(history),
        form: formReducer,
        timekeeper: timekeeperReducer,
        activeSeasonAlert: activeSeasonAlertReducer,
        activeIngredients: activeIngredientsReducer,
        appliedFertilizerEntitiesByDate: appliedFertilizerEntitiesByDateReducer,
        auth: authReducer,
        columnWidths: columnWidthsReducer,
        commodities: commoditiesReducer,
        connection: connectionReducer,
        containerGroups: containerGroupsReducer,
        counts: countsReducer,
        cropsurePasswords: cropsurePasswordsReducer,
        currentEntityId: currentEntityIdReducer,
        currentNumberOfDays: currentNumberOfDaysReducer,
        currentOrganizationId: currentOrganizationIdReducer,
        currentSeasonId: currentSeasonIdReducer,
        dates: datesReducer,
        descriptionSnippets: descriptionSnippetsReducer,
        documents: documentsReducer,
        documentSets: documentSetsReducer,
        entities: entitiesReducer,
        entityTypes: entityTypesReducer,
        equipment: equipmentReducer,
        equipmentSets: equipmentSetsReducer,
        error: errorReducer,
        errorBoundaries: errorBoundariesReducer,
        events: eventsReducer,
        fertilizerEvents: fertilizerEventsReducer,
        fertilizerProducts: fertilizerProductsReducer,
        finalForms: finalFormsReducer,
        finalFormsUnsavedValues: finalFormsUnsavedValuesReducer,
        groups: groupsReducer,
        groupEntities: groupEntitiesReducer,
        groupPeople: groupPeopleReducer,
        harvestEventDocuments: harvestEventDocumentsReducer,
        harvestEvents: harvestEventsReducer,
        harvestPrintProperties: harvestPrintPropertiesReducer,
        hashes: hashesReducer,
        hideUnusedGroups: hideUnusedGroupsReducer,
        initialDataLoaded: initialDataLoadedReducer,
        loading: loadingReducer,
        myTimesheetEntries: myTimesheetEntriesReducer,
        notifications: notificationsReducer,
        organizations: organizationsReducer,
        organizationConfig: organizationConfigReducer,
        payrollExports: payrollExportReducer,
        people: peopleReducer,
        productTypes: productTypesReducer,
        products: productsReducer,
        pickTypes: pickTypesReducer,
        quantityForecasts: quantityForecastsReducer,
        reEntryWarning: reEntryWarningReducer,
        reportsHarvestInspections: reportsHarvestInspectionsReducer,
        reportsHarvestInspectionsPeople: reportsHarvestInspectionsPeopleReducer,
        results: resultsReducer,
        roles: rolesReducer,
        schemas: schemasReducer,
        schemaAttributes: schemaAttributesReducer,
        searches: searchesReducer,
        seasons: seasonsReducer,
        selectedSprayEventIdsForSubmission:
            selectedSprayEventIdsForSubmissionReducer,
        selectedTableCells: selectedTableCellsReducer,
        sharedEvent: sharedEventReducer,
        sprayedEntitiesByDate: sprayedEntitiesByDateReducer,
        sprayEvents: sprayEventsReducer,
        sprayEventType: sprayEventTypeReducer,
        sprayEventsForSubmission: sprayEventsForSubmissionReducer,
        sprayEventWizard: sprayEventWizardReducer,
        sprayEventMultipleOperatorsTab: sprayEventMultipleOperatorsTabReducer,
        spraySubmission: spraySubmissionReducer,
        spraySubmissions: spraySubmissionsReducer,
        worksheet: worksheetReducer,
        submitting: submittingReducer,
        timesheetTimesheetEntriesAPIErrors:
            timesheetTimesheetEntriesAPIErrorsReducer,
        timesheet: timesheetReducer,
        timesheetEntries: timesheetEntriesReducer,
        timesheetHolidays: timesheetHolidaysReducer,
        timesheets: timesheetsReducer,
        timesheetTimesheetEntries: timesheetTimesheetEntriesReducer,
        ui: uiReducer,
        unitTypes: unitTypesReducer,
        userEntityAssignments: userEntityAssignmentsReducer,
        usersMe: usersMeReducer,
        varieties: varietiesReducer,
        virtualizedTable: virtualizedTableReducer,
        waterSource: waterSourceReducer,
        workTypes: workTypesReducer,
        resetPassword: resetPasswordReducer,
        onlyMyTimesheetsCheckbox: onlyMyTimesheetsCheckboxReducer
    });
